import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { observabilityApi, type MetricDefinition } from '../../api/observability';

export function MetricsExplorerPage() {
  const [metrics, setMetrics] = useState<MetricDefinition[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void observabilityApi.metrics().then(setMetrics).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/observability" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Operations Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Metrics Explorer</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-4 divide-y rounded-lg border dark:border-slate-700">
        {metrics.map((m) => (
          <li key={m.id} className="px-4 py-3 text-sm">
            <span className="font-medium">{m.name}</span>
            <span className="ml-2 text-slate-500">{m.type}</span>
            {m.unit && <span className="ml-2 text-slate-400">{m.unit}</span>}
          </li>
        ))}
        {metrics.length === 0 && !error && <li className="px-4 py-6 text-center text-slate-500">No metrics registered</li>}
      </ul>
    </div>
  );
}
